export var CNPJ_OCR_FIELD_ALIASES = ['cnpj_card', 'social_contract', 'statute'];
export var isCnpjOcrField = function (field) {
    var fieldAlias = field.field.toLowerCase();
    return CNPJ_OCR_FIELD_ALIASES.some(function (alias) { return fieldAlias.includes(alias); });
};
export var isCnpjOcrDecision = function (step) { return (step.type === 'DECISION' && step.fields.some(isCnpjOcrField)); };
export var canSkipTokenSearchForCnpjDecision = function (trustedDecision, tokenOnboarding, currentStep, selectedField) { return Boolean(trustedDecision
    && trustedDecision.source === 'PASSKEY_PUT'
    && trustedDecision.tokenOnboarding === tokenOnboarding
    && trustedDecision.step === currentStep.step
    && trustedDecision.stepName === currentStep.stepName
    && currentStep.type === 'DECISION'
    && isCnpjOcrField(selectedField)
    && currentStep.fields.some(function (currentField) { return (currentField.field === selectedField.field && isCnpjOcrField(currentField)); })); };
